import { ofType, StateObservable } from 'redux-observable';
import { debounceTime, filter, Observable, tap } from 'rxjs';
import { StoreCartRequest } from 'src/js/model/checkout/request/StoreCart';
import { FULFILLED } from '../../common/actions/ActionUtils';
import { DEFAULT_CONFIG_KEY, DefaultConfig } from '../../constants/Config';
import CartService from '../../services/CartService';
import { IshState } from '../../services/IshState';
import { Actions } from '../../web/actions/Actions';
import { REWRITE_CONTACT_NODE_TO_STATE, REWRITE_CONTACT_NODES_TO_STATE } from '../containers/summary/actions/Actions';
import { BuildContactNodes } from '../services/CheckoutService';

export const EpicStoreCartState = (function () {
  return (action$: Observable<any>, store: StateObservable<IshState>) => action$.pipe(
    ofType(
      FULFILLED(Actions.ADD_CLASS_TO_CART),
      FULFILLED(Actions.REMOVE_CLASS_FROM_CART),
      FULFILLED(Actions.ADD_PRODUCT_TO_CART),
      FULFILLED(Actions.REMOVE_PRODUCT_FROM_CART),
      FULFILLED(Actions.ADD_PROMOTION_TO_CART),
      FULFILLED(Actions.REMOVE_PROMOTION_FROM_CART),
      REWRITE_CONTACT_NODES_TO_STATE,
      REWRITE_CONTACT_NODE_TO_STATE
    ),
    debounceTime(1000),
    tap(async () => {
      const state = store.value;
      const payerId = state.checkout.payerId;

      if (payerId) {
        const storedCartData:StoreCartRequest = {
          payerId: state.checkout.payerId,
          checkoutURL: location.origin + (window[DEFAULT_CONFIG_KEY]?.checkoutPath || DefaultConfig.CHECKOUT_PATH),
          ...state.checkout.amount?.total ? { total: state.checkout.amount?.total?.toString() } : {},
          ...state.cart.promotions?.result?.length ? { promotionIds: state.cart.promotions.result } : {},
          contacts: []
        };

        const contactNodes = await BuildContactNodes.fromState(state.checkout.summary, state);

        if (contactNodes && contactNodes.length) {
          storedCartData.contacts = contactNodes.map(CartService.contactNodeToCartContact);
          CartService.create(payerId, storedCartData)
            .catch(() => {
              console.error('Failed to upload cart data');
            });
        }
      }
    }),
    filter(() => false)
  );
}());